import { Component, EventEmitter, Inject, OnInit, Output, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { SecurityController } from '@shared/src/controllers/security/security.controller';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { TruckingRouteDto } from '@shared/src/dtos/trucking/TruckingRouteDto';
import { TruckingRouteExpandDto } from '@shared/src/dtos/trucking/TruckingRouteExpandDto';
import { TruckingController } from '@shared/src/controllers/trucking/trucking.controller';
import { TruckingShipmentPackageDto } from '@shared/src/dtos/trucking/TruckingShipmentPackageDto';
import { OptionsStripDto } from '@shared/src/dtos/maintenance/option/OptionsStripDto';
import { OptionDto } from '@shared/src/dtos/maintenance/option/OptionDto';
import { ChatController } from '@shared/src/public-api';
import { TruckingShipmentDto } from '@shared/src/dtos/trucking/TruckingShipmentDto';
import { TruckingRouteExecuteActionDto } from '@shared/src/dtos/trucking/TruckingRouteExecuteActionDto';
import { TruckingRouteActions } from '@shared/src/enums/TruckingRouteActions';


@Component({
	selector: 'shared-trucking-route-panel-load',
	templateUrl: './shared.trucking.route.panel.load.component.html',
	styleUrls: ['./shared.trucking.route.panel.load.component.scss']
})
export class SharedTruckingRoutePanelLoadComponent implements OnInit {

	public useIonic: boolean = false;
	public iReadonly: boolean = false;

	public searchTextGroup: string = "";
	public filterMetadata: any = {};


	@Output() clickBack = new EventEmitter<boolean>();
	@Output() updateRoute = new EventEmitter<TruckingRouteDto>();

	constructor(
		public truckingController: TruckingController,
		public chatController: ChatController,
		public fb: FormBuilder,
		@Inject('HomeController') protected homeController: HomeController,
		@Inject("SecurityController") protected securityController: SecurityController,
		@Inject("AlertService") protected alertService: AlertService) {
		this.securityController.getStoredUserDto().subscribe(data => {
			this.iReadonly = data.isReadOnly;
		});

		if (homeController.useIonic)
			this.useIonic = homeController.useIonic();

	}


	ngOnInit(): void {
		
	}

	public _selectedRouteExpand: TruckingRouteExpandDto;
	@Input()
	public get selectedRouteExpand(): TruckingRouteExpandDto {
		return this._selectedRouteExpand;
	}
	public set selectedRouteExpand(value: TruckingRouteExpandDto) {
		if (this._selectedRouteExpand === value)
			return;
		this._selectedRouteExpand = value;
		this.loadOptions();
	}

	public options: OptionsStripDto;
	public actualOptionId: string = "PACKAGE";
	public loadOptions() {
		if(this.selectedRouteExpand == null){
			this.options = null;
			return;
		}
			
		let result = new OptionsStripDto();
		result.add(OptionDto.build("PACKAGE", "TRUCKING.ROUTE.OPCIONS.PACKAGE.CAPTION", "TRUCKING.ROUTE.OPCIONS.PACKAGE.HELP", "", 1, -1, 1, true, false));
		result.add(OptionDto.build("SHIPMENT", "TRUCKING.ROUTE.OPCIONS.SHIPMENT.CAPTION", "TRUCKING.ROUTE.OPCIONS.SHIPMENT.HELP", "", 2, -1, 1, false, false));
		result.add(OptionDto.build("DELIVERY", "TRUCKING.ROUTE.OPCIONS.DELIVERY.CAPTION", "TRUCKING.ROUTE.OPCIONS.DELIVERY.HELP", "", 3, -1, 1, false, false));
		if(this.selectedRouteExpand.canReorderRoute)
			result.add(OptionDto.build("ORDERSHIPMENTSINROUTE", "TRUCKING.ROUTE.OPCIONS.ORDERSHIPMENTSINROUTE.CAPTION", "TRUCKING.ROUTE.OPCIONS.ORDERSHIPMENTSINROUTE.HELP", "", 4, -1, 1, false, false));
		this.actualOptionId = result.getActualSelected().optionId;
		this.options = result;
	}

	onClickOption(option: OptionDto) {
		this.actualOptionId = option.optionId;
	}


	

	public selectedPackage: TruckingShipmentPackageDto;
    onClickPackage(item: TruckingShipmentPackageDto){
        this.selectedPackage = item;
    }

	public selectedShipment: TruckingShipmentDto;
	onClickShipment(item: TruckingShipmentDto) {
		this.selectedShipment = item;
	}

	onRefreshShipmentList(value: boolean){
        if(value){
			this.truckingController.refreshShipmentList$.next(true);
        }
    }

	onBrokenRoute() {
		if(this.selectedRouteExpand == null || this.selectedRouteExpand.isBrokenForTrucking || this.selectedRouteExpand.isTrucked)
			return;

		this.truckingController.executeAction(TruckingRouteExecuteActionDto.build(TruckingRouteActions.BrokenRoute, this.selectedRouteExpand.routeId, 0, 0)).subscribe(data => {
			if(data)
                this.truckingController.refreshShipmentList$.next(true);
                this.truckingController.routeChanged$.next(this.selectedRouteExpand.routeId);
		});
				
	}
	onUnBrokenRoute() {
		if(this.selectedRouteExpand == null || !this.selectedRouteExpand.isBrokenForTrucking)
			return;

		this.truckingController.executeAction(TruckingRouteExecuteActionDto.build(TruckingRouteActions.UnBrokenRoute, this.selectedRouteExpand.routeId, 0, 0)).subscribe(data => {
			if(data)
                this.truckingController.refreshShipmentList$.next(true);
                this.truckingController.routeChanged$.next(this.selectedRouteExpand.routeId);
		});
				
	}
}
